import { Account, AccountRequest } from "../domain/account.interface";
import { instanceBo } from "../utils/axios.create";

export const accountService = {
	async createAccount(accountData: AccountRequest): Promise<Account> {
		const response = await instanceBo.post("/accounts", accountData);
		return response.data.body.account;
	},

	async getAccounts(): Promise<Account[]> {
		const response = await instanceBo.get("/accounts");
		// Backend returns accounts directly in body array, not body.accounts
		return Array.isArray(response.data.body)
			? response.data.body
			: response.data.body.accounts || [];
	},

	async getAccount(accountId: string): Promise<Account> {
		// Note: This endpoint might need to be implemented in the backend
		const response = await instanceBo.get(`/accounts/${accountId}`);
		return response.data.body.account;
	},
};
